module.exports = __webpack_public_path__ + "franchise-12.png?c838c5fd3e469ac9484baaf085db06b9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/franchise-12.png
// module id = 279
// module chunks = 0